import { Col, Container, Row } from "react-bootstrap"
import { useParams } from "react-router"
import { useState } from "react"
import BookingGuestEntry from "../../../Components/BookingGuests/BookingGuestEntry/BookingGuestEntry"
import useMyProperties from "../../../Hooks/UseMyProperties/UseMyPropertiesHook"
import { useGetBookingByIdQuery, useGetBookingGuestByIdQuery, useSendBookingGuestEmailMutation } from "../../../services/bClientApi"
import { ConfirmModal } from "../../../Components/Modals/confirmModal"
import { useAppDispatch } from "../../../redux/store"
import { showSuccess } from "../../../redux/counter/counterSlice"
import canAccess from "../../../services/accessService/accessService"

export default function BookingGuestPage() {

  const dispatch = useAppDispatch()
  const { myProperties } = useMyProperties()
  const { bookingGuestId = '' } = useParams()
  // const { _id, bookingGuestData, message, loading, error } = useSelector(bookingGuestSelector)

  const [sendBookingGuestEmail, { isLoading: sendBookingGuestEmailLoading }] = useSendBookingGuestEmailMutation()

  const [activeConfirmationModal, setActiveConfirmationModal] = useState({
    active: false,
    title: '',
    message: '',
    onConfirm: () => { },
    onClose: () => { }
  })

  const resetConfirmationModal = () => {
    setActiveConfirmationModal({
      active: false,
      title: '',
      message: '',
      onConfirm: () => { },
      onClose: () => { }
    })
  }

  const {
    data,
    isLoading,
    error
  } = useGetBookingGuestByIdQuery(bookingGuestId, { skip: !bookingGuestId })

  const bookingGuestData = data || {}

  const { propertyId } = bookingGuestData

  const {
    data: bookingData,
    // isLoading: bookingDataLoading,
    // isFetching: bookingDataFetching,
  } = useGetBookingByIdQuery(bookingGuestData?.bookingId, { skip: !bookingGuestData?.bookingId })


  const propertyData: any = propertyId && myProperties[propertyId] ? myProperties[propertyId] : {}

  const extraButtons = []

  if (bookingGuestData && canAccess('bookingGuest', 'sendConfirm')) {
    extraButtons.push({
      label: `${bookingGuestData.status !== 'new' ? 'Resend ' : 'Send '}✉️`,
      disabled: sendBookingGuestEmailLoading,
      variant: 'primary',
      onClick: async () => {
        setActiveConfirmationModal({
          active: true,
          title: `${bookingGuestData.status !== 'new' ? 'Resend' : 'Send'} Confirmation Email`,
          message: `Are you sure you want to ${bookingGuestData.status !== 'new' ? 'resend' : 'send'} the confirmation email?`,
          onConfirm: async () => {
            const mailInfo = await sendBookingGuestEmail(
              bookingGuestData._id
            ).unwrap()
            console.log('mailInfo', mailInfo)
            dispatch(showSuccess('Email sent'))
          },
          onClose: resetConfirmationModal
        })
      }
    })
  }

  return (
    <Container>
      <Row>
        <Col>
          <h1>Single BookingGuest Page</h1>
          <hr />
          {error && (<>{JSON.stringify(error)}<br /></>)}

          {bookingGuestId && !isLoading && bookingGuestData && (
            <div className="booking-guestinfo">
              {/* <pre>
                {JSON.stringify(bookingGuestData, null, 2)}            
              </pre> */}
              <BookingGuestEntry
                bookingGuestInfo={bookingGuestData}
                bookingData={bookingData}
                propertyData={propertyData}
                extraButtons={extraButtons}
              />
            </div>
          )}
        </Col>
      </Row>

      <ConfirmModal
        active={activeConfirmationModal.active}
        title={activeConfirmationModal.title}
        message={activeConfirmationModal.message}
        onConfirm={() => {
          activeConfirmationModal.onConfirm()
          resetConfirmationModal()
        }}
        onClose={() => {
          activeConfirmationModal.onClose()
        }}
      />

    </Container>
  )
}
